<div class="change-ship-date-dialog">
  <div class="change-ship-date-content">
    <!-- Selected Skid Count -->
    <div class="mb-3">
      <span class="font-semibold">Selected MVPS(s) {{ selectedCount }}</span>
    </div>

    <form [formGroup]="changeShipDateForm">
      <!-- Transit Days -->
      <div class="mb-3">
        <label for="transitDays" class="modal-label">Transit Days</label>
        <p-inputNumber
          id="transitDays"
          formControlName="transitDays"
          [showButtons]="true"
          [min]="0"
          [max]="30"
          class="w-full"
          [disabled]="true">
        </p-inputNumber>
      </div>

      <!-- New Shipping Date -->
      <div class="mb-3">
        <label for="newShipDate" class="modal-label">New Shipping Date</label>
        <p-datePicker
          id="newShipDate"
          formControlName="newShipDate"
          [showIcon]="true"
          [showOnFocus]="false"
          dateFormat="mm/dd/yy"
          placeholder="month/day/year"
          (onSelect)="onShipDateChange()"
          appendTo="body"
          class="w-full">
        </p-datePicker>
      </div>

      <!-- New Arrival Date (Auto-calculated) -->
      <div class="mb-3">
        <label for="newArrivalDate" class="modal-label">New Arrival Date</label>
        <p-datePicker
          id="newArrivalDate"
          formControlName="newArrivalDate"
          [showIcon]="true"
          [showOnFocus]="false"
          dateFormat="mm/dd/yy"
          placeholder="month/day/year"
          [disabled]="true"
          appendTo="body"
          class="w-full">
        </p-datePicker>
      </div>
    </form>
  </div>

  <!-- Dialog Footer -->
  <div class="modal-footer">
    <button type="button" class="modal-btn-cancel" (click)="onClose()">Close</button>
    <button type="button" class="modal-btn-primary" (click)="onApply()" [disabled]="!changeShipDateForm.valid">Apply</button>
  </div>
</div>
